class InfoTabs extends HTMLElement {
  constructor() {
    super();

    this.desktopBreakpoint = 1024;
    this.infoTabs = [...this.querySelectorAll('.info-tab')];

    this.addEventListener('click', this.handleClick.bind(this));
    window.addEventListener('resize', this.handleResize.bind(this));

    this.handleResize();
  }

  handleClick(e) {
    const button = e.target.closest('.js-info-tab-trigger');
    if (!button) return;

    const tab = this.querySelector(`#${button.dataset.tab}`);
    if (!tab) return;

    const isDesktop = window.innerWidth >= this.desktopBreakpoint;
    const isActive = tab.classList.contains('active');

    if (isDesktop) {
      if (isActive) return;
      this.openTab(tab);
    } else {
      isActive ? this.closeTab(tab) : this.openTab(tab);
    }
  }

handleResize() {
  const isDesktop = window.innerWidth >= this.desktopBreakpoint;

  if (isDesktop) {
    const openTab = this.querySelector('.info-tab.active');
    if (!openTab && this.infoTabs.length) {
      this.openTab(this.infoTabs[0]);
    }
  } else {
    this.infoTabs.forEach(tab => {
      const panel = document.getElementById(tab.dataset.panel);
      if (tab.classList.contains('active')) {
        panel.style.height = panel.scrollHeight + 'px';
      }
    });
  }
}

  openTab(tab) {
    this.infoTabs.forEach(t => {
      if (t !== tab) this.closeTab(t);
    });

    const panel = document.getElementById(tab.dataset.panel);
    const buttons = this.querySelectorAll(`.js-info-tab-trigger[data-tab="${tab.id}"]`);

    tab.classList.add('active');
    buttons.forEach(btn => btn.classList.add('active'));
    buttons.forEach(btn => btn.setAttribute('aria-expanded', 'true'));
    panel.setAttribute('aria-hidden', 'false');

    this.animateOpen(panel);
  }

  closeTab(tab, animate = true) {
    const panel = document.getElementById(tab.dataset.panel);
    const buttons = this.querySelectorAll(`.js-info-tab-trigger[data-tab="${tab.id}"]`);

    tab.classList.remove('active');
    buttons.forEach(btn => btn.classList.remove('active'));
    buttons.forEach(btn => btn.setAttribute('aria-expanded', 'false'));
    panel.setAttribute('aria-hidden', 'true');

    if (animate) this.animateClose(panel);
    else panel.style.height = '0px';
  }

animateOpen(panel) {
  panel.style.height = panel.scrollHeight + 'px';

  panel.addEventListener(
    'transitionend',
    function handler(e) {
      if (e.target !== panel) return;
      panel.style.height = 'auto';
      panel.removeEventListener('transitionend', handler);
    }
  );
}

  animateClose(panel) {
    panel.style.height = panel.scrollHeight + 'px';
    panel.offsetHeight;
    requestAnimationFrame(() => {
      panel.style.height = '0px';
    });
  }
}

customElements.define('info-tabs', InfoTabs);